import cApi from './cApi'

class cUtilFecha {
  //--------calculamos la edad segun la fecha de nacimiento
  //let suma = cUtilFecha.calcEdad(); //edad = 12
  static edad(dateString) {
    let hoy = new Date()
    let fechaNacimiento = new Date(dateString)
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear()
    let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth()
    if (
      diferenciaMeses < 0 ||
      (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
    ) {
      edad--
    }
    return edad
  }
  //-----------------------------------------------------
  static fechaActual(){
    const today  = new Date();
    const dia = cApi.zeroFill( today.getDate(),2);
    const mes = cApi.zeroFill( today.getMonth() + 1, 2);
    const anio = today.getFullYear();
    const fechaHoy =  `${anio}-${mes}-${dia}`;
    return fechaHoy;
  }
  //-----------------
  //---------------------2023-02-22--------------------------------
  static fechaActualMy(){
    const today  = new Date();
    const dia = today.getDate();
    const mes = today.getMonth() + 1;
    const anio = today.getFullYear();
    const fechaHoy =  `${anio}-${mes<10?`0${mes}`:`${mes}`}-${dia}`;
    return fechaHoy;
  }
}

export default cUtilFecha;